import { render, staticRenderFns } from "./StaticViewBuilder.vue?vue&type=template&id=5dff07da"
import script from "./StaticViewBuilder.vue?vue&type=script&lang=ts"
export * from "./StaticViewBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports